/* Psolys · home: the brush film (one layer, in front of the giant word), Kairo’s intro, the ritual ring,
   "pour toi" tabs, the diagrams of the dark section, the 2 minute timer, the guide form. */
(() => {
  const { $, $$, reduce } = window.psolys;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const smooth = x => x * x * (3 - 2 * x);
  const root = document.documentElement;

  /* ---------- hero ---------- */
  const hero = $('[data-hero]');
  if (root.classList.contains('js-intro')) {
    try { sessionStorage.setItem('psolys.intro', '1'); } catch (e) {}
    setTimeout(() => root.classList.remove('js-intro'), 3400);
  }
  if (hero && !reduce) {
    /* 120 rendered frames of the real brush, drawn on one canvas that sits in front of the giant word */
    const N = 120, FACE = 90 / 210;
    const small = matchMedia('(max-width: 900px), (max-aspect-ratio: 4/5)').matches;
    const canvas = $('canvas[data-layer]', hero), ctx = canvas.getContext('2d'), stage = $('[data-stage]', hero);
    const seq = hero.dataset.seq || 'assets/seq/{set}/f{n}.webp';
    const src = i => seq.replace('{set}', small ? 'sm' : 'lg').replace('{n}', String(i).padStart(3, '0'));
    const frames = new Array(N);
    let want = 0, drawn = -1, raf = 0, rest = false;
    const nearest = i => { for (let d = 0; d < N; d++) { if (frames[i - d]) return i - d; if (frames[i + d]) return i + d; } return -1; };
    const draw = () => {
      const k = nearest(want); if (k < 0 || k === drawn) return;
      drawn = k; ctx.clearRect(0, 0, canvas.width, canvas.height); ctx.drawImage(frames[k], 0, 0, canvas.width, canvas.height);
      hero.classList.add('is-ready');
    };
    const copy = $('.hero__copy', hero);
    const size = () => {
      hero.style.setProperty('--copy-h', copy.offsetHeight + 'px');   /* phones fit the brush above the text */
      const r = stage.getBoundingClientRect(), dpr = Math.min(devicePixelRatio || 1, 3);
      canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.width * dpr); drawn = -1; draw();
    };
    const order = [], seen = new Set();
    [0, Math.round(FACE * (N - 1)), N - 1].concat(...[24, 12, 6, 3, 1].map(s => Array.from({ length: Math.ceil(N / s) }, (_, j) => j * s)))
      .forEach(i => { if (i < N && !seen.has(i)) { seen.add(i); order.push(i); } });
    let next = 0, busy = 0;
    const pump = () => {
      while (busy < 6 && next < order.length) {
        const i = order[next++]; busy++;
        const img = new Image(); img.decoding = 'async'; img.src = src(i);
        (img.decode ? img.decode() : new Promise((res, rej) => { img.onload = res; img.onerror = rej; }))
          .then(() => { frames[i] = img; if (drawn < 0 || Math.abs(i - want) < Math.abs(drawn - want)) { drawn = -1; draw(); } })
          .catch(() => {}).finally(() => { busy--; pump(); });
      }
    };
    /* scroll to angle, with rests on the hero pose, the S face-on and the picots */
    const K = [[0, 0], [.1, 0], [.4, FACE], [.55, FACE], [.86, 1], [1, 1]];
    const toT = p => { for (let j = 1; j < K.length; j++) { const [p0, t0] = K[j - 1], [p1, t1] = K[j]; if (p <= p1) return t0 + (t1 - t0) * smooth(clamp((p - p0) / (p1 - p0))); } return 1; };
    const ring = $('[data-chip-ring]', hero);
    const setRest = on => {
      if (on === rest) return; rest = on; hero.classList.toggle('is-rest', on);
      ring.setAttribute('stroke', on ? 'var(--color-moment-rest)' : 'var(--color-moment-push)');
      ring.setAttribute('stroke-dashoffset', on ? '.02' : '.14');
    };
    const update = () => {
      raf = 0;
      const total = hero.offsetHeight - innerHeight; if (total <= 0) return;
      const p = clamp(-hero.getBoundingClientRect().top / total);
      want = Math.round(toT(p) * (N - 1)); draw();
      if (!rest && p > .74) setRest(true); else if (rest && p < .68) setRest(false);
    };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    addEventListener('resize', () => { size(); update(); });
    size(); pump(); update();
    if (document.fonts) document.fonts.ready.then(() => { size(); update(); });
  }

  /* ---------- ritual ring: counts up to 2:00 ---------- */
  const ready = $('[data-ready]');
  if (ready) ready.addEventListener('reveal', () => {
    const num = $('[data-count]', ready), ringEl = $('.ring', ready), target = +num.dataset.count;
    const fmt = s => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
    const run = () => {
      if (reduce) { num.textContent = fmt(target); ringEl.classList.add('done'); return; }
      const t0 = performance.now(), dur = 1400;
      const tick = t => { const k = clamp((t - t0) / dur); num.textContent = fmt(Math.round(target * (1 - Math.pow(1 - k, 3)))); if (k < 1) requestAnimationFrame(tick); else ringEl.classList.add('done'); };
      requestAnimationFrame(tick);
    };
    setTimeout(run, reduce ? 0 : 900);
  }, { once: true });

  /* ---------- pour toi: tabs ---------- */
  const T = {
    psoriasis: { label: 'Psoriasis', word: 'APAISER', img: 'thumb', rgb: '111,162,135',
      headline: 'Pensée par une psoriasis girl, pour les psoriasis girls.',
      sub: 'Plaques, squames, démangeaisons. Elle décolle en douceur, sans racler, là où tes ongles blessent.' },
    dermite: { label: 'Dermite séborrhéique', word: 'SQUAMES', img: 'face', rgb: '125,68,43',
      headline: 'Utile dès qu’il y a des squames à décoller en douceur.',
      sub: 'Dermite séborrhéique, pellicules tenaces. Ses picots fins soulèvent sans racler.' },
    courts: { label: 'Cheveux courts', word: 'DIRECT', img: 'picots', rgb: '111,162,135',
      headline: 'Sur cheveux courts, les picots touchent la peau directement.',
      sub: 'Même problème, même geste. Deux minutes de petits cercles avant la douche.' },
    offrir: { label: 'À offrir', word: 'OFFRIR', img: 'thumb', rgb: '125,68,43',
      headline: 'Quelqu’un de ton entourage a du psoriasis ?',
      sub: 'Une brosse crème et vert sauge, dans un packaging soigné avec sa carte de remerciement.' }
  };
  const sport = $('[data-sport]');
  if (sport) {
    const order = Object.keys(T); let cur = 'psoriasis', timer;
    const word = $('[data-sport-word]', sport), copy = $('[data-sport-copy]', sport), tabs = $('[data-sport-tabs]', sport);
    tabs.innerHTML = order.map(id => `<button type="button" role="tab" id="t-${id}" aria-selected="${id === cur}" tabindex="${id === cur ? 0 : -1}" data-id="${id}" style="--c:rgb(${T[id].rgb})"><span class="dot"></span>${T[id].label}</button>`).join('');
    const mark = id => $$('[role=tab]', tabs).forEach(b => { const on = b.dataset.id === id; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1; });
    const f = n => $(`[data-f="${n}"]`, copy);
    const select = id => {
      if (id === cur) return; cur = id; mark(id); const s = T[id];
      sport.style.setProperty('--rgb', s.rgb);
      $$('[data-img]', sport).forEach(img => img.classList.toggle('is-on', img.dataset.img === s.img));
      word.classList.add('out'); copy.classList.add('out'); clearTimeout(timer);
      timer = setTimeout(() => { word.textContent = s.word; word.classList.remove('out'); f('headline').textContent = s.headline; f('sub').textContent = s.sub; copy.classList.remove('out'); }, reduce ? 0 : 320);
    };
    tabs.addEventListener('click', e => { const b = e.target.closest('[role=tab]'); if (b) select(b.dataset.id); });
    tabs.addEventListener('keydown', e => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      e.preventDefault(); const all = $$('[role=tab]', tabs); let i = all.indexOf(document.activeElement);
      i = e.key === 'Home' ? 0 : e.key === 'End' ? all.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + all.length) % all.length;
      all[i].focus(); select(all[i].dataset.id);
    });
  }

  /* ---------- the 2 minute timer ---------- */
  const tm = $('[data-timer]');
  if (tm) {
    const TOTAL = 120, arc = $('.arc', tm), timeEl = $('[data-time]', tm), zoneEl = $('[data-zone]', tm), say = $('[data-say]', tm);
    const start = $('[data-start]', tm), reset = $('[data-reset]', tm);
    let left = TOTAL, base = TOTAL, t0 = 0, run = false, tick = 0, zone = 0;
    const fmt = s => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
    const paint = () => {
      timeEl.textContent = fmt(Math.ceil(left)); arc.style.strokeDashoffset = (1 - left / TOTAL).toFixed(4);
      if (!run) return;
      const z = Math.min(4, Math.floor((TOTAL - left) / 30) + 1);
      if (z !== zone) { zone = z; zoneEl.textContent = `Zone ${z} sur 4`; say.textContent = z === 1 ? 'Petits cercles, sans appuyer.' : 'Change de zone. Petits cercles, sans appuyer.'; }
    };
    const finish = () => { run = false; left = 0; paint(); start.textContent = 'Lancer les 2 minutes'; zoneEl.textContent = 'Terminé'; say.textContent = 'C’est fait. Place à la douche.'; };
    const loop = now => { if (!run) return; left = Math.max(0, base - (now - t0) / 1000); paint(); if (left <= 0) finish(); else tick = requestAnimationFrame(loop); };
    start.addEventListener('click', () => {
      if (run) { run = false; cancelAnimationFrame(tick); base = left; start.textContent = 'Reprendre'; say.textContent = 'En pause.'; return; }
      if (left <= 0) { left = TOTAL; zone = 0; }
      run = true; base = left; t0 = performance.now(); start.textContent = 'Pause'; reset.hidden = false; tick = requestAnimationFrame(loop);
    });
    reset.addEventListener('click', () => { run = false; cancelAnimationFrame(tick); left = base = TOTAL; zone = 0; start.textContent = 'Lancer les 2 minutes'; zoneEl.textContent = '4 zones, 30 secondes chacune'; say.textContent = 'Petits cercles, sans appuyer.'; reset.hidden = true; paint(); });
    paint();
  }

  /* ---------- the guide form (not wired to Shopify yet) ---------- */
  $$('[data-form]').forEach(f => f.addEventListener('submit', e => {
    const st = $('[data-status]', f), email = f.querySelector('input[type=email]').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { e.preventDefault(); st.textContent = 'Vérifie ton adresse e-mail.'; f.querySelector('input[type=email]').focus(); return; }
    if (window.psolys.SHOPIFY) {
      /* Shopify saves the address as a customer who accepts marketing, with tags to tell the lists apart */
      const tags = f.querySelector('input[name="contact[tags]"]'), oil = f.querySelector('input[name=huile]');
      if (tags && oil && oil.checked && !/huile/.test(tags.value)) tags.value += ', huile';
      return;
    }
    e.preventDefault();
    st.textContent = 'Merci. Cette version de travail n’envoie encore rien\u00a0: l’inscription sera reliée à Shopify à la mise en ligne.';
  }));
})();
